import { render } from "./DesktopLocaleSelector.vue?vue&type=template&id=058b03d9&scoped=true"
import script from "./DesktopLocaleSelector.vue?vue&type=script&lang=js"
export * from "./DesktopLocaleSelector.vue?vue&type=script&lang=js"

import "./DesktopLocaleSelector.vue?vue&type=style&index=0&id=058b03d9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058b03d9"]])

export default __exports__